"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    fullScreenSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=full-screen.theme.js.map